export const sapIdAttrName = 'SAP ID';

// Only 400 responses carry user-facing validation messages in the `error` field;
// other statuses (e.g. 500) may contain internal details that must not be shown.
export const extractApiValidationErrorMessage = (err: unknown): string | undefined => {
  const httpError = err as { status?: number; error?: { error?: unknown } };
  if (httpError?.status !== 400) return undefined;
  const message = httpError?.error?.error;
  return typeof message === 'string' && message.trim().length > 0 ? message : undefined;
};

export const isSapIdConflictError = (err: unknown): boolean =>
  extractApiValidationErrorMessage(err)?.includes(sapIdAttrName) ?? false;
